import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import { Box, Button } from '@mui/material';

import useStyles from './styles';

const ALL = 'All';
const ALPHABET = Array.from({ length: 26 }, (_, n) => String.fromCharCode(97 + n));
const NUMBERS = Array.from({ length: 10 }, (_, n) => String(n));
const SPECIALS = [',', '@'];

const OPTIONS = [ALL, ...ALPHABET, ...NUMBERS, ...SPECIALS];

const LetterFilter = ({ selected, onSelect, getOptionHref, className }) => {
    const { classes, cx } = useStyles();

    const handleSelect = useCallback(
        (event) => {
            event.preventDefault();
            const { option } = event.currentTarget.dataset;
            const value = option === ALL ? '' : option.toLowerCase();
            onSelect && onSelect(value);
        },
        [onSelect]
    );

    return (
        <Box className={cx(classes.container, className)}>
            {OPTIONS.map((option) => {
                const additional = getOptionHref
                    ? { component: 'a', href: getOptionHref(option === ALL ? null : option) }
                    : {};
                return (
                    <Button
                        key={option}
                        className={cx(classes.button, { [classes._selected]: option === (selected || ALL) })}
                        variant="outlined"
                        data-option={option}
                        onClick={handleSelect}
                        {...additional}
                    >
                        {option}
                    </Button>
                );
            })}
        </Box>
    );
};

LetterFilter.propTypes = {
    selected: PropTypes.string,
    onSelect: PropTypes.func,
    getOptionHref: PropTypes.func,
    className: PropTypes.string
};

export default LetterFilter;
